import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { userActions } from '../../store/modules/user';

const useDeleteAccountHandler = () => {
  const dispatch = useDispatch();
  const handler = useCallback(() => dispatch(userActions.deleteAccount()), []);

  return handler;
};

export default useDeleteAccountHandler;
